	export enum AppointmentTypeGroupEnum {
		Eval = 1,
		FineTune = 2,
		CheckUp = 3,
		Fitting = 4,
		Repair = 5,
		Diagnostics = 6,
		Other = 7,
		AnnualCheck = 8
	}
